export function swapIndexes<T>(arr: T[], index1: number, index2: number) {
  if (
    index1 < 0 ||
    index1 >= arr.length ||
    index2 < 0 ||
    index2 >= arr.length
  ) {
    console.error('Invalid indexes')
    return
  }

  const [deletedNode] = arr.splice(index1, 1)
  arr.splice(index2, 0, deletedNode!)

  return arr
}
